export const fullName = (names: string[]): string => {
  return names
    .map((name) => name?.trim())
    .filter((n) => n != null && n != '')
    .join(' ');
};
